import React from "react";
import { ITableDatabase } from "../../../interfaces/tableDatabase";
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";

import {
  ButtomIndex,
  ContainerIndexTable,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  TrBody,
} from "./index.style";

export default function Index(props: ITableDatabase) {
  const { header, tableRows, numOfLine } = props;

  const [dataStorage, setDataStorage] = React.useState<any[][]>(tableRows);
  const [indexData, setIndexData] = React.useState<number>(0);
  const [dataforShow, setDataForShow] = React.useState<Array<any>[]>([]);
  const MAX_NUMBER_OF_LINE = 6;

  const getNumOfIndex = React.useCallback(
    () =>
      dataStorage.length % (numOfLine || MAX_NUMBER_OF_LINE) === 0
        ? Math.floor(dataStorage.length / (numOfLine || MAX_NUMBER_OF_LINE))
        : Math.floor(dataStorage.length / (numOfLine || MAX_NUMBER_OF_LINE)) +
          1,
    [dataStorage, numOfLine]
  );
  const [numOfDataIndex, setNumOfDataIndex] = React.useState<number>(
    getNumOfIndex()
  );
  // Set Data when index changed
  const setRangeData = React.useCallback(() => {
    const startData = indexData * (numOfLine || MAX_NUMBER_OF_LINE);
    const endData =
      startData + (numOfLine || MAX_NUMBER_OF_LINE) > dataStorage.length
        ? dataStorage.length
        : startData + (numOfLine || MAX_NUMBER_OF_LINE);
    setNumOfDataIndex(getNumOfIndex());
    setDataForShow(dataStorage.slice(startData, endData));
  }, [dataStorage, indexData, numOfLine, getNumOfIndex]);
  React.useEffect(setRangeData, [indexData, setIndexData, setRangeData]);

  // Set data when parent change data
  const handleChangeData = React.useCallback(() => {
    if (tableRows.length === dataStorage.length) return;
    setDataStorage(tableRows);
  }, [tableRows, dataStorage.length, setDataStorage]);
  React.useEffect(handleChangeData, [tableRows, handleChangeData]);

  // Reset index when changed data
  React.useEffect(() => {
    setIndexData(0);
  }, [dataStorage]);

  const increaseIndex = () => {
    const newIndex = indexData + 1;
    if (newIndex >= numOfDataIndex) return;
    setIndexData(newIndex);
  };

  const reduceIndex = () => {
    const newIndex = indexData - 1;
    if (newIndex <= -1) return;
    setIndexData(newIndex);
  };

  return (
    <div>
      <Table>
        <Thead>
          <tr>
            {header.map((item, index) => (
              <Th key={index}>{item}</Th>
            ))}
          </tr>
        </Thead>
        <Tbody>
          {dataforShow.map((item, index) => [
            <tr key={"top-space-" + index}>
              <td>
                <div style={{ height: 6, backgroundColor: "transparent" }} />
              </td>
            </tr>,
            <TrBody key={index}>
              {item.map((ele, k) => (
                <Td
                  isOdd={index % 2 === 0}
                  key={k}
                  isFirst={k === 0}
                  isLast={k === item.length - 1}
                >
                  {ele}
                </Td>
              ))}
            </TrBody>,
            <tr key={"bottom-space-" + index}>
              <td>
                <div style={{ height: 6, backgroundColor: "transparent" }} />
              </td>
            </tr>,
          ])}
        </Tbody>
      </Table>
      {numOfDataIndex !== 0 && (
        <IndexTableComponent
          reduceIndex={reduceIndex}
          increaseIndex={increaseIndex}
          current={indexData}
          numOfIndex={numOfDataIndex}
          onPressItem={(index) => setIndexData(index - 1)}
        />
      )}
    </div>
  );
}

export const IndexTableComponent = ({
  current,
  numOfIndex,
  onPressItem = () => {},
  reduceIndex = () => {},
  increaseIndex = () => {},
}: {
  current: number;
  numOfIndex: number;
  onPressItem: (index: number) => void;
  reduceIndex: () => void;
  increaseIndex: () => void;
}) => {
  const listIndex = (number: number) => {
    let array = [];
    for (let index = 0; index < number; index++) {
      array.push(index + 1);
    }
    return array;
  };

  return (
    <ContainerIndexTable>
      <p style={{ margin: 0, marginRight: "1rem" }}>
        แสดง {current + 1} จากทั้งหมด {numOfIndex}
      </p>
      <span
        style={{ fontSize: "24px", marginBottom: "4px", cursor: "pointer" }}
        onClick={reduceIndex}
      >
        <IoMdArrowDropleft />
      </span>
      {listIndex(numOfIndex).map((item, index) => (
        <ButtomIndex
          key={`bt-index-${index}`}
          onClick={() => onPressItem(item)}
          isActive={current + 1 === item}
        >
          {item}
        </ButtomIndex>
      ))}
      <span
        style={{ fontSize: "24px", marginBottom: "4px", cursor: "pointer" }}
        onClick={increaseIndex}
      >
        <IoMdArrowDropright />
      </span>
    </ContainerIndexTable>
  );
};
